/**
 * Returns an object of arrays.
 * The key being the main root group name.
 *
 * For example Reports, Students, Utilities...
 *
 * @param {array} data
 * @returns {object}
 */
export const groupByRoot = (data = []) => {
  const groups = {};

  data.forEach(item => {
    if (groups[item.GroupName] === undefined) groups[item.GroupName] = [];

    groups[item.GroupName].push(item);
  });

  return groups;
};

/**
 *  Returns an array of objects.
 *  If PageId maps to a entry item attach a preferences array to object.
 *
 *  {
 *    Id: 2123,
 *    GroupName: 'Administration',
 *    FunctionName: 'Allergen Setup',
 *    SubGroupName: 'District Settings',
 *    Read: true,
 *    Write: true,
 *    PageId: null,
 *    Preferences: [{}, ...]
 *  }
 *
 * @param {array} data
 * @returns {array}
 */
export const groupPreferencesByPageId = data => {
  const rawPreferences = data.filter(item => item.AccessInfoId);
  const groupedPreferences = {};

  rawPreferences.forEach(preference => {
    if (groupedPreferences[preference.AccessInfoId] === undefined)
      groupedPreferences[preference.AccessInfoId] = [];

    groupedPreferences[preference.AccessInfoId].push(preference);
  });

  return data
    .map(item => {
      if (typeof groupedPreferences[item.Id] === undefined) return item;

      return {
        ...item,
        Preferences: groupedPreferences[item.Id],
      };
    })
    .filter(item => !item.AccessInfoId);
};



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/helpers/grouping.js